import { makeRequest } from "./request";

export const getMariaData = async () => await makeRequest.get<API.Maria.MariaData.Response>("/maria/configs/");

export const updateMariaData = async (data: API.Maria.UpdateMaria.Request) =>
  await makeRequest.patch<API.Maria.UpdateMaria.Response>("/maria/configs/", data);

export const getMariaPropertyList = async (data: API.Maria.MonitorList.Request) =>
  await makeRequest.get<API.Maria.MonitorList.Response>("/maria/monitors/get_maria_properties/", { params: data });

export const updateMariaInterestedLevel = async (data: API.Maria.MonitorList.UpdateInterestedLevel.Request) =>
  await makeRequest.post<API.Maria.MonitorList.UpdateInterestedLevel.Response>("/maria/monitors/update_interested_level/", data);
